<template>
  <component
    :is="isDialog ? 'q-dialog' : 'div'"
    v-model="shown"
    :maximized="isDialog && $q.screen.lt.md"
    :style="!isDialog ? { display: 'block' } : {}"
  >
    <q-card
      :style="{
        width: $q.screen.lt.md ? '100vw' : 'min(95vw, 1600px)',
        height: $q.screen.lt.md ? '100vh' : 'min(85vh, calc(100vh - 40px))',
        overflow: 'hidden',
        display: 'flex',
        'flex-direction': 'column'
      }"
    >
      <q-card-section
        class="row items-center q-pb-none"
        style="flex-shrink: 0; min-height: 60px;"
      >
        <div class="text-h6">
          Hotschedules Webclock
        </div>
        <q-space />
        <q-btn
          v-if="isDialog"
          v-close-popup
          icon="close"
          flat
          round
          dense
          @click="shown = false"
        />
        <q-btn
          v-else
          color="primary"
          label="Go to Register"
          @click="goToRegister"
        />
      </q-card-section>
      <q-card-section
        class="q-pt-sm"
        style="flex: 1; overflow: hidden; padding-left: 0; padding-right: 0; padding-bottom: 0;"
      >
        <iframe
          src="https://www.hotschedules.com/hs/webclock/"
          style="width: 100%; height: 100%; border: none; display: block;"
          frameborder="0"
          allowfullscreen
        />
      </q-card-section>
    </q-card>
  </component>
</template>
<script>
import config from 'src/config'

export default {
  name: 'HotscheduleDialog',
  props: {
    isDialog: {
      type: Boolean,
      default: true
    },
    showByDefault: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      shown: false
    }
  },
  watch: {
    showByDefault: {
      handler () {
        this.shown = this.showByDefault
      },
      immediate: true
    }
  },
  methods: {
    show () {
      this.shown = true
    },
    hide () {
      this.shown = false
    },
    goToRegister () {
      this.$router.push(config.posRoot)
    }
  }
}
</script>
